
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faReceipt,
    faHandHoldingDollar, faCoins
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

interface EventTabsProps {
    activeTab: 'expenses' | 'balances' | 'payments';
    expenseCount: number;
    onTabChange: (tab: 'expenses' | 'balances' | 'payments') => void;
}

const EventTabs: React.FC<EventTabsProps> = ({
                                                 activeTab,
                                                 expenseCount,
                                                 onTabChange
                                             }) => {
    const { t } = useTranslation();
    return (
        <div className="mb-8">
            <div className="glass-tab-bar flex space-x-1 overflow-x-auto scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                    <button
                        onClick={() => onTabChange('expenses')}
                        className={`glass-tab flex items-center flex-shrink-0 ${
                            activeTab === 'expenses' ? 'glass-tab-active' : ''
                        }`}
                    >
                        <FontAwesomeIcon icon={faReceipt} className="mr-2" />
                        {t('event.tabs.expenses')}
                        {expenseCount > 0 && (
                            <span className="ml-2 glass-badge py-0.5 px-2 text-xs">
                                {expenseCount}
                            </span>
                        )}
                    </button>

                    <button
                        onClick={() => onTabChange('balances')}
                        className={`glass-tab flex items-center flex-shrink-0 ${
                            activeTab === 'balances' ? 'glass-tab-active' : ''
                        }`}
                    >
                        <FontAwesomeIcon icon={faCoins} className="mr-2" />
                        {t('event.tabs.balances')}
                    </button>

                    <button
                        onClick={() => onTabChange('payments')}
                        className={`glass-tab flex items-center flex-shrink-0 ${
                            activeTab === 'payments' ? 'glass-tab-active' : ''
                        }`}
                    >
                        <FontAwesomeIcon icon={faHandHoldingDollar} className="mr-2" />
                        {t('event.tabs.payments')}
                    </button>
            </div>
        </div>
    );
};

export default EventTabs;